import {
  ApiFile,
  AppFile,
  EntityStatus,
  ErrorType,
  JourneyStatus,
} from './core';
import { TranslationRecord } from './language';

export enum InvoiceStatus {
  PendingApproval = 'PendingApproval',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export interface InvoiceListItem {
  id: string;
  invoiceNumber: string;
  year: number;
  month: number;
  contractId: string;
  contractName: string;
  operatorId: string;
  operatorName: string;
  status: InvoiceStatus;
}

export interface Invoice<TFile = ApiFile> {
  id: string;
  invoiceNumber: string;
  year: number;
  month: number;
  contractId: string;
  files: TFile[];
  status: InvoiceStatus;
}

export type NewInvoice = Omit<Invoice<AppFile>, 'id' | 'status'>;

export type CreateInvoiceResponse = {
  invoice: Invoice | null;
  errors: InvoiceValidationEntry[] | null;
};

export interface InvoiceInfo {
  year: number;
  month: number;
  contractId: string;
}

export const isInvoiceInfo = (data: unknown): data is InvoiceInfo => {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return false;
  }
  const objectData = data as Record<PropertyKey, unknown>;
  return (
    typeof objectData.year === 'number' &&
    typeof objectData.month === 'number' &&
    typeof objectData.contractId === 'string'
  );
};

export interface InvoiceJourney {
  id: string;
  day: string;
  time: string;
  departurePortId: string;
  departurePortName: TranslationRecord;
  arrivalPortId: string;
  arrivalPortName: TranslationRecord;
  isAdhoc: boolean;
  journeyStatus: JourneyStatus;
  entityStatus: EntityStatus;
}
export interface InvoiceValidationEntry {
  type: ErrorType;
  message: string;
}

export interface InvoiceValidationErrors {
  errors: InvoiceValidationEntry[];
}

export interface InvoiceRejectionNote {
  id: string;
  note: string;
  creationDate: string;
  type: 'Rejected';
}
